import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useEmployees } from '../../hooks/useEmployees';
import EmployeesDashboard from '../../components/admin/EmployeesDashboard';

const EmpleadosPage = () => {
  const { employees, error, isLoading } = useEmployees();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar empleados.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <EmployeesDashboard
        windows={employees}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de empleados:', newOrder);
        }}
      />
    </Box>
  );
};

export default EmpleadosPage;